import c from "./tour.colors";

export const tourTokens = {
  glass: {
    background: c.surface,
    blur: "blur(24px)",
    border: `1px solid ${c.surfaceBorder}`,
    mobile: {
      background: c.surfaceMobile,
    },
  },

  tooltip: {
    width: 420,
    maxWidth: "calc(100vw - 32px)",
    radius: "18px",
    padding: "24px 24px 20px",
    gap: "14px",
    shadow: `${c.shadow.card}, ${c.shadow.cardHairline}`,
    mobile: {
      width: 350,
      radius: "16px",
      padding: "18px 18px 15px",
      gap: "11px",
      shadow: c.shadow.cardMobile,
    },
  },

  close: {
    offset: "14px",
    size: 30,
    radius: "8px",
    iconSize: 14,
    iconStroke: 2.2,
    color: c.closeIcon,
    hoverBg: c.hoverBg,
    hoverColor: c.textPrimary,
    mobile: {
      offset: "11px",
      size: 28,
      radius: "7px",
      iconSize: 13,
    },
  },

  title: {
    fontSize: "16px",
    fontWeight: 800,
    color: c.textPrimary,
    paddingRight: "30px",
    mobile: {
      fontSize: "14.5px",
      paddingRight: "28px",
    },
  },

  body: {
    fontSize: "13px",
    fontWeight: 400,
    lineHeight: 1.65,
    color: c.textSecondary,
    mobile: {
      fontSize: "12.5px",
      lineHeight: 1.6,
    },
  },

  footer: {
    gap: "10px",
    paddingTop: "6px",
    mobile: {
      paddingTop: "4px",
    },
  },

  progress: {
    gap: "10px",
    dotSize: 8,
    dotGap: "5px",
    dotActive: c.dotActive,
    dotInactive: c.dotInactive,
    maxDots: 5,
    counterFontSize: "11.5px",
    counterFontWeight: 700,
    counterColor: c.textMuted,
    mobile: {
      gap: "8px",
      dotSize: 7,
      dotGap: "4px",
      counterFontSize: "10.5px",
    },
  },

  actions: {
    gap: "8px",
    height: 34,
    tapArea: 44,
    radius: "9px",
    fontSize: "12.5px",
    fontWeight: 700,

    ghostPaddingX: "14px",
    ghostBorder: `1px solid ${c.ghostBorder}`,
    ghostBg: c.ghostBg,
    ghostColor: c.textSecondary,
    ghostHoverBorderColor: c.textPrimary,
    ghostHoverColor: c.textPrimary,

    primaryPaddingX: "16px",
    primaryBg: c.primary,
    primaryHoverBg: c.primaryHover,
    primaryColor: c.onPrimary,
    primaryGap: "6px",
    chevronSize: 11,
    chevronStroke: 2.5,

    mobile: {
      gap: "6px",
      height: 30,
      radius: "8px",
      fontSize: "11.5px",
      ghostPaddingX: "12px",
      primaryPaddingX: "14px",
      primaryGap: "5px",
      chevronSize: 10,
    },
  },

  overlay: {
    color: c.overlay,
    spotlightRadius: 12,
    spotlightPadding: 8,
    cutoutBorderColor: c.spotlightBorder,
    cutoutBorderWidth: 2,
    viewportPadding: 16,
  },

  arrow: {
    size: 16,
    base: 32,
    color: c.surface,
  },

  modal: {
    width: 420,
    maxWidth: "calc(100vw - 32px)",
    radius: "22px",
    padding: "32px",
    gap: "16px",
    blur: "blur(28px)",
    background: c.modal.surface,
    border: `1px solid ${c.surfaceBorder}`,
    shadow: c.shadow.modal,

    iconSize: 64,
    welcomeIconRadius: "18px",
    welcomeIconBg: c.modal.welcomeTile,
    welcomeIconColor: c.modal.welcomeIcon,
    welcomeGlyphSize: 28,
    welcomeGlyphStroke: 1.8,
    completeIconRadius: "50%",
    completeIconBg: c.modal.completeTile,
    completeIconColor: c.modal.completeIcon,
    completeGlyphSize: 30,
    completeGlyphStroke: 2.4,

    titleFontSize: "20px",
    titleFontWeight: 800,
    titleColor: c.textPrimary,

    bodyFontSize: "13.5px",
    bodyLineHeight: 1.65,
    bodyColor: c.textSecondary,
    bodyMaxWidth: 340,

    actionsGap: "9px",
    actionsMarginTop: "6px",
    buttonHeight: 44,
    buttonRadius: "11px",
    buttonFontSize: "14px",
    buttonFontWeight: 700,
    buttonGap: "8px",
    chevronSize: 13,

    footnoteFontSize: "11.5px",
    footnoteColor: c.modal.footnote,
    footnoteMarginTop: "2px",
  },

  launcher: {
    tileSize: 40,
    tileRadius: "12px",
    iconSize: 20,
    paddingX: "20px",
    paddingY: "12px",
    gap: "12px",
    titleFontSize: "14px",
    titleFontWeight: 700,
    titleLineHeight: 1.35,
    descriptionFontSize: "12px",
    descriptionFontWeight: 500,
  },

  focus: {
    width: "2px",
    offset: "2px",
    color: c.primary,
  },
} as const;

export default tourTokens;
